import { ApiResponse } from "shared/Types/responseTypes"
import { get, post } from "shared/Helpers/http"
import { CurrentEnvironment } from "shared/Modules/Environment/envTypes"
import { UserAccountsResponse } from "mobile/Screens/Me/changeAccountTypes"
import { AuthenticationResponse } from "shared/Modules/Login/loginTypes"

export function sendConfirmationLink(
    token: string,
    environment: CurrentEnvironment,
    userId: number
): Promise<ApiResponse<UserAccountsResponse>> {
    return post(`/users/${userId}/sendConfirmEmail`, {
        token,
        environment,
    })
}

export function getUserAccounts(
    token: string,
    environment: CurrentEnvironment,
    userId: number
): Promise<ApiResponse<UserAccountsResponse>> {
    return get(`/users/${userId}/userAccounts`, {
        token,
        environment,
    })
}

export interface IChangeUserRequest {
    user: {
        username: string
    }
}

export function changeAccount(
    request: IChangeUserRequest,
    userId: number,
    token: string,
    environment: CurrentEnvironment
): Promise<ApiResponse<AuthenticationResponse>> {
    return post(`/users/${userId}/changeAccount`, {
        body: request,
        token,
        environment,
    })
}
